var bootstrap = require('bootstrap');

$( document ).ready(() => {
  $( "input.file.form-control[type='file']" ).each((i, e) => {
    const target = $(e);
    const imgUrl = target.attr('data-uploaded-file');

    if (_.isNil(imgUrl))
    {
      return;
    }

    target.wrapAll('<div class="input-group"></div>');
    const wrapperInputGroup = target.parent();
    const button = $( `<a class="btn btn-secondary" href="${imgUrl}" target="_blank" ref="noopener"><i class="bi bi-eye-fill"></i></button>` );
    wrapperInputGroup.append(button);
    var popover = new bootstrap.Popover(button, {
      content: `<img src="${imgUrl}" class="w-100">`,
      html: true
    });

    button.on('mouseover', (e) => {
      popover.show();
    });
    button.on('mouseleave', (e) => {
      popover.hide();
    });
  });
});
